import { Sport } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

export const useShowProOnboardingBadge = () => {
  const { currentUser } = useCurrentUserContext();
  const { sport } = useSportContext();

  // Read the sport-explicit `footballUserProfile`, not `anyUserSportProfile`:
  // the latter is keyed by the `$sport` derived from the URL, which disagrees
  // with the sport context on paths without a sport prefix (landing, /cards/:slug,
  // the card dialog), and would surface another sport's `proOnboarded` here.
  return (
    sport === Sport.FOOTBALL &&
    currentUser?.footballUserProfile?.proOnboarded === false
  );
};
